import FormItemsFactory from '../../factories/form-items-factory';
import { IFormLayout } from '../../types/layout/form';
import { useFormData } from '../../hooks/form/useFormData';
import { INestedLayoutParams } from '../../types/components';

function Form({ fields, nestedParams }: IFormLayout & INestedLayoutParams) {
    useFormData({ nestedParams });

    return (
        <form className="row">
            <FormItemsFactory fields={fields} />
        </form>
    );
}

export default Form;
